import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import classes from './ContactForm.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeContext } from '../../../../App';

export default function ContactForm() {
  const notifySuccess = () =>
    toast.success('Your message has been sent successfully!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: theme,
    });

  const name = useInput('', { isEmpty: true, minLength: 3, maxLength: 25 });
  const email = useInput('', {
    isEmpty: true,
    minLength: 3,
    maxLength: 25,
    isEmail: true,
  });
  const message = useInput('', { isEmpty: true, minLength: 5, maxLength: 100 });

  const [phone, setPhone] = useState('');
  const [isPhoneValidate, setIsPhoneValidate] = useState(false);
  const [isPhoneDirty, setPhoneDirty] = useState(false);

  const phoneBlur = () => {
    setPhoneDirty(true);
  };

  const formRef = useRef<HTMLFormElement | null>(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const sendEmail = async () => {
    try {
      if (!formRef.current) {
        return;
      }

      //const formData = new FormData(formRef.current);
      const data = {
        name: name.value,
        email: email.value,
        phone: phone,
        message: message.value,
      };

      console.log(data);

      const response = await fetch('https://api.fptech-us.com/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.text();
      console.log(result);
    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  const setPhoneHandler = (value: string) => {
    setPhone(value);

    setFormData({
      ...formData,
      phone: phone,
    });
  };

  const clickSubmit = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();

    sendEmail();
    name.reset();
    email.reset();
    message.reset();
    setPhone('');

    setPhoneDirty(false);

    notifySuccess();
  };

  useEffect(() => {
    if (!phone) {
      setIsPhoneValidate(false);
      return;
    }

    if (isValidPhoneNumber(phone)) {
      // Assuming there is a setPhoneValid function to handle phone input validity
      setIsPhoneValidate(true);
    } else {
      // Assuming there is a setPhoneValid function to handle phone input validity
      setIsPhoneValidate(false);
    }
  }, [phone, name]);

  const { theme } = useContext(ThemeContext);

  const MymyInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
    word: any,
  ) => {
    word.onChange(e);

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      ref={formRef}
      id={classes[theme]}
      className="flex flex-col md:text-mdAddTxt lg:text-lg2AddTxt"
    >
      <ValidateErrors input={name} min={3} max={25} />
      <input
        name="name"
        id="name"
        type="text"
        value={name.value}
        onChange={(e) => MymyInputChange(e, name)}
        onBlur={(e) => name.onBlur(e)}
        placeholder="Name:"
        className="mb-5 lg:mb-2 text-smSepBtnTxt md:text-mdAddTxt lg:text-lg2AddTxt h-vh7 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      ></input>

      {email.isDirty && email.emailError && !email.isEmpty ? (
        <div data-testid="emailError" style={{ color: 'red' }}>
          Invalid email
        </div>
      ) : null}
      <ValidateErrors input={email} min={3} max={25} />
      <input
        name="email"
        id="email"
        type="text"
        value={email.value}
        onChange={(e) => MymyInputChange(e, email)}
        onBlur={(e) => email.onBlur(e)}
        placeholder="Email:"
        className="mb-5 lg:mb-2 text-smSepBtnTxt md:text-mdAddTxt lg:text-lg2AddTxt h-vh7 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      ></input>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme}
      />
      {isPhoneDirty && !phone ? (
        <div style={{ color: 'red', marginTop: '2vh' }}>
          The field cannot be empty
        </div>
      ) : null}
      {isPhoneDirty && phone && !isValidPhoneNumber(phone) ? (
        <div style={{ color: 'red', marginTop: '2vh' }}>
          The field is not correct
        </div>
      ) : null}
      <PhoneInput
        placeholder="Enter phone number"
        className={
          classes.myCustomInput +
          ' mb-5 lg:mb-2 text-smSepBtnTxt md:text-mdAddTxt lg:text-lg2AddTxt h-vh7'
        }
        value={phone}
        onChange={(value: string) => setPhoneHandler(value)}
        name="phone"
        id="phone"
        onBlur={phoneBlur}
      />

      <ValidateErrors input={message} min={5} max={100} />
      <textarea
        name="message"
        id="message"
        placeholder="Message:"
        value={message.value}
        onChange={(e) => MymyInputChange(e, message)}
        onBlur={(e) => message.onBlur(e)}
        className="mb-5 lg:mb-2 block pt-5 md:pt-10 md:pb-vh5-bottom  pl-2.5 lg:p-2.5 w-full  lg:leading-7 lg:min-h-24 text-smSepBtnTxt md:text-mdAddTxt lg:text-lg2AddTxt h-vh7 md:h-vh1 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      ></textarea>

      <input
        type="submit"
        onClick={(e) => clickSubmit(e)}
        disabled={
          !name.inputValid ||
          !email.inputValid ||
          !message.inputValid ||
          !isPhoneValidate
        }
        className=" text-smSepBtnTxt md:text-mdAddTxt lg:text-lg2AddTxt h-vh7 font-bold py-3 px-4 rounded-full mt-top-vh1"
        value={'SEND'}
      />
    </form>
  );
}

interface InputValidation {
  isDirty: boolean;
  isEmpty: boolean;
  minLengthError: boolean;
  maxLengthError: boolean;
}

interface ValidateErrorsProps {
  input: InputValidation;
  min: number;
  max: number;
}

const ValidateErrors: FC<ValidateErrorsProps> = ({ input, min, max }) => {
  return (
    <>
      {input.isDirty && input.isEmpty ? (
        <div style={{ color: 'red', marginTop: '2vh' }}>
          The field cannot be empty
        </div>
      ) : null}
      {input.isDirty && input.minLengthError ? (
        <div style={{ color: 'red', marginTop: '2vh' }}>
          The field must contain at least {min} symbols
        </div>
      ) : null}
      {input.isDirty && input.maxLengthError ? (
        <div style={{ color: 'red', marginTop: '2vh' }}>
          The field must contain a maximum of {max} symbols
        </div>
      ) : null}
    </>
  );
};

const useValidation = (value: string, validations: Validations) => {
  const [isEmpty, setEmpty] = useState(true);
  const [minLengthError, setMinLengthError] = useState(false);
  const [maxLengthError, setMaxLengthError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [inputValid, setInputValid] = useState(false);

  useEffect(() => {
    for (const validation in validations) {
      switch (validation) {
        case 'minLength':
          value.length < validations[validation] && value.length !== 0
            ? setMinLengthError(true)
            : setMinLengthError(false);
          break;
        case 'isEmpty':
          value ? setEmpty(false) : setEmpty(true);
          break;
        case 'maxLength':
          value.length > validations[validation]!
            ? setMaxLengthError(true)
            : setMaxLengthError(false);
          break;
        case 'isEmail':
          const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          re.test(String(value).toLowerCase())
            ? setEmailError(false)
            : setEmailError(true);
          break;
        default:
          return;
      }
    }
  }, [value, validations]);

  useEffect(() => {
    if (isEmpty || maxLengthError || minLengthError || emailError) {
      setInputValid(false);
    } else {
      setInputValid(true);
    }
  }, [isEmpty, maxLengthError, minLengthError, emailError]);

  return {
    isEmpty,
    minLengthError,
    emailError,
    maxLengthError,
    inputValid,
  };
};

interface Validations {
  isEmpty: boolean;
  minLength: number;
  isEmail?: boolean;
  maxLength?: number;
}

const useInput = (InitialValue: string, validations: Validations) => {
  const [value, setValue] = useState<string>(InitialValue);
  const [isDirty, setDirty] = useState(false);

  const valid = useValidation(value, validations);

  function onChange(
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) {
    setValue(e.target.value);
  }

  const onBlur = (e: React.FocusEvent) => {
    setDirty(true);
  };

  const reset = () => {
    setValue(InitialValue);

    setDirty(false);
  };

  return {
    value,
    onChange,
    onBlur,
    isDirty,
    ...valid,
    reset,
  };
};
